import publicLink from './publicLink';
import microservice from './microservice';
import microserviceSetting from './microserviceSetting';
/** @type {import('data/types').DataTypesConfig}*/

export default {
  publicLink: publicLink,
  microservice: microservice,
  microserviceSetting: microserviceSetting
};